export const initialState = {
	items: [],
	serverItems: [],
	isLoading: false,
	isLoaded: false,
	errorMessage: undefined
};

export default { initialState };
